module.exports = __webpack_public_path__ + "42ab821cabdd5e6397c6996c2c6db82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/bindWeixin.png
// module id = 320
// module chunks = 0